import { apiClient } from '@/shared/lib/apiClient';

export interface NotificationItem {
  id: string;
  userId: string;
  companyId: string;
  type: string;
  title: string;
  message: string;
  link: string | null;
  metadata: Record<string, unknown> | null;
  isRead: boolean;
  readAt: string | null;
  createdAt: string;
}

export interface PaginatedNotifications {
  data: NotificationItem[];
  meta: { page: number; limit: number; total: number; totalPages: number };
}

export interface GetNotificationsParams {
  page?: number;
  limit?: number;
  readStatus?: 'unread' | 'read' | 'all';
  dateFrom?: string;
  dateTo?: string;
}

export async function getNotifications(params: GetNotificationsParams = {}): Promise<PaginatedNotifications> {
  const query = new URLSearchParams();
  if (params.page) query.set('page', String(params.page));
  if (params.limit) query.set('limit', String(params.limit));
  if (params.readStatus) query.set('readStatus', params.readStatus);
  if (params.dateFrom) query.set('dateFrom', params.dateFrom);
  if (params.dateTo) query.set('dateTo', params.dateTo);
  const qs = query.toString();
  const response = await apiClient.get(`/notifications${qs ? `?${qs}` : ''}`);
  return response.data.data;
}

export async function getUnreadCount(): Promise<number> {
  const response = await apiClient.get('/notifications/unread-count');
  return response.data.data.count;
}

export async function markNotificationAsRead(id: string): Promise<NotificationItem> {
  const response = await apiClient.patch(`/notifications/${id}/read`);
  return response.data.data;
}

export async function markSelectedNotificationsAsRead(ids: string[]): Promise<number> {
  const response = await apiClient.patch('/notifications/mark-read', { ids });
  return response.data.data.count;
}

export async function markAllNotificationsAsRead(): Promise<number> {
  const response = await apiClient.patch('/notifications/read-all');
  return response.data.data.count;
}
